import Enforce0 from "../assets/images/ic_enforce_0.svg"
import Enforce1 from "../assets/images/ic_enforce_1.svg"
import Enforce2 from "../assets/images/ic_enforce_2.svg"
import Enforce3 from "../assets/images/ic_enforce_3.svg"
import Enforce4 from "../assets/images/ic_enforce_4.svg"
import Enforce5 from "../assets/images/ic_enforce_5.svg"
import Enforce6 from "../assets/images/ic_enforce_6.svg"
import Enforce7 from "../assets/images/ic_enforce_7.svg"
import Enforce8 from "../assets/images/ic_enforce_8.svg"
import Enforce9 from "../assets/images/ic_enforce_9.svg"
import Enforce10 from "../assets/images/ic_enforce_10.svg"
import Awaken1 from "../assets/images/ic_awaken_1.svg"
import Awaken2 from "../assets/images/ic_awaken_2.svg"
import Awaken3 from "../assets/images/ic_awaken_3.svg"
import Awaken4 from "../assets/images/ic_awaken_4.svg"
import Awaken5 from "../assets/images/ic_awaken_5.svg"
import Awaken6 from "../assets/images/ic_awaken_6.svg"
import Awaken7 from "../assets/images/ic_awaken_7.svg"
import Awaken8 from "../assets/images/ic_awaken_8.svg"
import Awaken9 from "../assets/images/ic_awaken_9.svg"
import styled from "styled-components"
import useOutsideClick from "../utils/useOutsideClick"

const Container = styled.div`
    display: flex;
    flex-direction: column;
    z-index: 6;
`
const EnforceHorizontalList = styled.div`
    display: flex;
    flex-direction: row;
    gap: 0.25rem;
`

const AwakenHorizontalList = styled.div`
    display: flex;
    flex-direction: row;
`

const EnforceItem = styled.img`
    width: 1.5rem;
    &:hover {
        cursor: pointer;
    }
`

const AwakenItem = styled.img`
    width: 2.125rem;
    &:hover {
        cursor: pointer;
    }
`

export default function LevelPopup({isVisible, onClose, onLevelSelected, isAllowAwaken}) {

    const dialogRef = useOutsideClick(onClose);

    const enforceList = [
        Enforce0, Enforce1, Enforce2, Enforce3, Enforce4, Enforce5, Enforce6, Enforce7, Enforce8, Enforce9, Enforce10
    ];

    const awakenList = [
        Awaken1, Awaken2, Awaken3, Awaken4, Awaken5, Awaken6, Awaken7, Awaken8, Awaken9
    ];

    return (
        isVisible && (
            <Container ref={dialogRef}>
                <EnforceHorizontalList>
                    {enforceList.map((src, index) => (
                        <EnforceItem 
                            key={index}
                            src={src}
                            onClick={() => onLevelSelected({
                                isAwaken: false,
                                level: index
                            })}
                        />
                    ))}
                </EnforceHorizontalList>

                {isAllowAwaken && <AwakenHorizontalList>
                    {awakenList.map((src, index) => (
                        <AwakenItem
                            key={index}
                            src={src}
                            onClick={() => onLevelSelected({
                                isAwaken: true,
                                level: index + 1
                            })}
                        />
                    ))}
                </AwakenHorizontalList>}
            </Container>
        )
    )

}